<template>
  <v-container class="minHeight" v-if="loaded">
    <v-card v-if="!hasRows" class="py-4">
      <v-layout>
        <v-flex>
          <v-btn
            outline
            round
            color="accent"
            class="initialize right"
            @click="
              isShowingGarageContactBottomSheet =
                !isShowingGarageContactBottomSheet
            "
          >
            {{ $t('tenant.button.contact') }}</v-btn
          >
          <v-btn
            outline
            round
            color="primary"
            class="initialize right"
            @click="
              isShowingGarageCodeBottomSheet = !isShowingGarageCodeBottomSheet
            "
          >
            {{ $t('tenant.button.applyCode') }}</v-btn
          >
        </v-flex>
      </v-layout>
      <advice color="primary">
        <p v-html="$t('tenant.noBuildings.message')"></p>
      </advice>
    </v-card>

    <v-card v-else>
      <v-layout>
        <v-flex>
          <v-btn
            outline
            round
            color="accent"
            class="initialize right"
            @click="
              isShowingGarageContactBottomSheet =
                !isShowingGarageContactBottomSheet
            "
          >
            {{ $t('tenant.button.contact') }}</v-btn
          >
          <v-btn
            outline
            round
            color="primary"
            class="initialize right"
            @click="
              isShowingGarageCodeBottomSheet = !isShowingGarageCodeBottomSheet
            "
          >
            {{ $t('tenant.button.applyCode') }}</v-btn
          >
        </v-flex>
      </v-layout>

      <v-layout row class="pb-4 mt-3">
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="buildings"
            hide-actions
            expand
            hide-headers
            item-key="id"
          >
            <template slot="items" slot-scope="props">
              <td class="justify-center">
                <v-img
                  height="50"
                  :aspect-ratio="16 / 9"
                  :src="props.item.image"
                >
                </v-img>
              </td>
              <td class="text-xs-center">{{ props.item.name }}</td>
              <td class="text-xs-center">{{ props.item.address }}</td>
              <td class="justify-center layout px-0">
                <v-btn
                  icon
                  class="primary"
                  color="primary"
                  outline
                  @click="props.expanded = !props.expanded"
                >
                  <v-icon>timelapse</v-icon>
                </v-btn>
              </td>
            </template>
            <template slot="expand" slot-scope="props">
              <v-flex xs12 class="pl-4 pt-4">
                {{ $t('tenant.rules.tip') }}
              </v-flex>
              <v-list class="py-0 ml-5">
                <v-list-tile v-for="rule in props.item.rules" :key="rule">
                  {{ rule.start | formatDateTimeAsLocal }}
                  -
                  <template v-if="isUndefined(rule.end)">
                    {{ $t('global.noEndDate') }}
                  </template>
                  <template v-else>
                    {{ rule.end | formatDateTimeAsLocal }}
                  </template>
                </v-list-tile>
              </v-list>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <garage-apply-code
      v-if="isShowingGarageCodeBottomSheet"
      @on-success="getuserBuildings"
      @on-close="closeGarageCodeBottomSheet"
    ></garage-apply-code>

    <garage-contact-form
      v-if="isShowingGarageContactBottomSheet"
      @on-success="getuserBuildings"
      @on-close="closeGarageContactBottomSheet"
    ></garage-contact-form>
  </v-container>
</template>

<script>
import Advice from '@/components/commons/Advice';
import GarageApplyCode from '@/components/private/tenant/GarageApplyCode';
import GarageContactForm from '@/components/private/tenant/GarageContactForm';
import sessionService from '@/services/sessionService';
import tenantService from '@/services/tenantService';
import manageErrorService from '@/services/manageErrorService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import moment from 'moment';

export default {
  name: 'Tenant',
  components: {
    [GarageApplyCode.name]: GarageApplyCode,
    [GarageContactForm.name]: GarageContactForm,
    [Advice.name]: Advice
  },
  computed: {
    user() {
      return store.state.user;
    },
    token() {
      return this.$route.query.token;
    },
    headers() {
      return [
        {
          i18nText: '',
          text: '',
          align: 'right',
          value: ''
        },
        {
          i18nText: '',
          text: '',
          align: 'center',
          value: 'parking'
        },
        {
          i18nText: '',
          text: '',
          align: 'center',
          value: 'address'
        },
        {
          i18nText: '',
          text: '',
          align: 'right',
          value: ''
        }
      ];
    }
  },
  data() {
    return {
      selectedBuilding: {},
      loaded: false,
      hasRows: false,
      isShowingGarageCodeBottomSheet: false,
      isShowingGarageScheculeDialog: false,
      isShowingGarageContactBottomSheet: false,
      buildings: []
    };
  },
  created() {
    this.getuserBuildings();
    if (this.token) {
      this.useToken();
    }
  },
  methods: {
    async getuserBuildings() {
      await sessionService.check(true);
      this.buildings = store.state.user.tenant;

      if (this.buildings === null || this.buildings.length === 0) {
        this.hasRows = false;
      } else {
        this.hasRows = true;
      }
      this.loaded = true;
    },

    async useToken() {
      let form = {
        code: this.token.replace(/\s/g, '')
      };

      let results = await tenantService.acceptInvitation(form);
      if (results.error) {
        if (results.status === 404) {
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: 'tenant.token.invalid',
            type: 'error',
            doNotTranslate: false,
            timeout: 6000
          });
        } else {
          manageErrorService.handle(results.data);
        }

        this.isLoading = false;
        this.valid = true;
        return;
      }

      this.getuserBuildings();
    },

    closeGarageScheduleBottomSheet(item) {
      this.isShowingGarageScheculeDialog = false;
      this.selectedGarage = item;
    },

    closeGarageCodeBottomSheet() {
      this.isShowingGarageCodeBottomSheet = false;
    },

    closeGarageContactBottomSheet(item) {
      this.isShowingGarageContactBottomSheet = false;
    },

    isUndefined(end) {
      return moment(end).year() === 2100;
    }
  }
};
</script>

<style>
.v-datatable__expand-col.v-datatable__expand-col--expanded {
  border-bottom: none !important;
}
</style>
